﻿/**
 * portal-admin-settingkeys.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-admin-settings.controller', portalAdminSettingsController);

	/** setup injection */
	portalAdminSettingsController.$inject = ['$uibModal', 'config.repository'];

	/** implementation */
	function portalAdminSettingsController($uibModal, configRepo) {
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.settings = [];

		/** public methods */
		vm.openModal = openModal;

		/** run init */
		init();

		/** public method implementations */

		/** open a modal for editing */
		function openModal(setting) {
			/** create the modal instance */
			$uibModal.open({
				templateUrl: 'app/portal-admin/portal-admin-settings/setting-modal.html',
				controller: 'setting-modal.controller',
				controllerAs: 'settingModalCtrl',
				size: 'lg',
				resolve: {
					allSettings: function () {
						return vm.settings;
					},
					setting: function() {
						return setting;
					},
					parentInit: function() {
						return init;
					}
				}
			});
		}

		/** private methods */

		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** load links */
			configRepo.getSettings().then(function(settings) {
				/** set settings */
				vm.settings = settings;

				/** flip loading flag */
				vm.loading = false;
			});
		}
	}
})();